export default function CheckboxGroup({
  value,
  onChange,
  options,
  label,
  helperText,
  disabled = false,
  displayCompact = false,
  error,
}: {
  value: string[];
  onChange?: (value: string[]) => void;
  options: { label: string; value: string; helperText?: string }[];
  label: string;
  helperText?: string;
  disabled?: boolean;
  displayCompact?: boolean;
  error?: string;
}) {
  const handleChange = optionValue => {
    let newValue;

    if (value)
      newValue = value?.includes(optionValue)
        ? value?.filter(v => v !== optionValue)
        : [...value, optionValue];
    else newValue = [optionValue];

    onChange!(newValue);
  };

  return (
    <fieldset>
      <legend className="sr-only">{label}</legend>
      <span className={'text-sm font-medium text-gray-900'}>{label}</span>
      <span className="text-sm text-gray-500 block">{helperText}</span>
      <div className={displayCompact ? 'mt-3' : 'space-y-5'}>
        {options.map(option => (
          <div key={option.value} className="relative flex items-start mt-1">
            <div className="flex h-6 items-center">
              <input
                id={option.value}
                aria-describedby={`${option.value}`}
                name={option.value}
                type="checkbox"
                checked={value?.includes(option.value)}
                onChange={() => handleChange(option.value)}
                className="h-4 w-4 rounded  border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:ring-offset-0 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:border-gray-300 disabled:text-gray-500 disabled:checked:bg-gray-300 disabled:checked:border-transparent disabled:checked:text-gray-900 disabled:checked:cursor-not-allowed"
                disabled={disabled}
              />
            </div>
            <div className="ml-3 text-sm leading-6 select-none">
              <label htmlFor={option.value} className={''}>
                {option.label}
              </label>
              <p id={`${option.value}-helperText`} className="text-gray-500">
                {option.helperText}
              </p>
            </div>
          </div>
        ))}
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600" id="error">
          {error}
        </p>
      )}
    </fieldset>
  );
}
